import { Globals } from "./Globals";
import { QRFC } from "./QRFC";

export class QTalentSearchRFC extends QRFC {
  constructor() {
    super();
  }

  InitTalentSearch(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, data) {
    this.AddParameter("mode", "talentSearch");
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    this.AddParameter("data", data);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    if (success) {
      callBackObj.resolve?.(r["data"]);
    } else {
      callBackObj.resolve?.([]);
    }

    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();
  }
}
